import { Observable } from '../Observable';
export function fromSubscribable(subscribable) {
  return new Observable(function (subscriber) {
    return subscribable.subscribe(subscriber);
  });
}